<template>
  <card>
    <modal :show.sync="addClockForm"
           body-classes="p-0"
           modal-classes="modal-dialog-top modal-sm"
           :scrollToBottom="false"
           :centered="false">
      <add-clock-panel :dates="dates" @add-clock="addClock"/>
    </modal>
    <div class="card-body">
      <div class="row" style="margin-top: -15px;">
        <base-input class="col-md-4 col-lg-4 px-md-1" label="Employee full name">
            <select v-model="filter.employee_id" class="form-control">
              <option value="0">All</option>
              <option v-for="employee in employees" :value="employee.employee_id" :key="employee.employee_id">{{employee.first_name + ' ' + employee.last_name}}</option>
            </select>
          </base-input>
        <base-input class="col-md-4 col-lg-4 px-md-1" label="Project full name">
            <select v-model="filter.project_id" class="form-control">
              <option value="0">All</option>
              <option v-for="project in projects" :value="project.project_id" :key="project.project_id">{{project.full_name}}</option>
            </select>
          </base-input>
        <base-input class="col-md-4 col-lg-4 px-md-1" label="Employee role in system">
          <select v-model="filter.type_id" class="form-control">
            <option value="0">All</option>
            <option v-for="type in types" :value="type.type_id" :key="type.type_id">{{type.name}}</option>
          </select>
        </base-input>
      </div>
      <div class="row" style="margin-top: 15px;">
        <base-input class="col-lg-2 col-md-4 col-6" label="Deleted">
          <base-radio name="empty" class="mb-3" v-model="radioValue1">
            Ignore this
          </base-radio>
          <base-radio name="True" class="mb-3" v-model="radioValue1">
            Yes
          </base-radio>
          <base-radio name="False" class="mb-3" v-model="radioValue1">
            No
          </base-radio>
      </base-input>
        <base-input class="col-lg-2 col-md-4 col-6" label="Confirmed">
          <base-radio name="empty" class="mb-3" v-model="radioValue2">
            Ignore this
          </base-radio>
          <base-radio name="True" class="mb-3" v-model="radioValue2">
            Yes
          </base-radio>
          <base-radio name="False" class="mb-3" v-model="radioValue2">
            No
          </base-radio>
        </base-input>
      </div>
      <div class="row" style="margin-top: 15px;">
        <div class="col-md-4" style="text-align: right;">
          <base-button class="clock-button" size="lg" simple block type="primary" @click="getData">Obtain information</base-button>
        </div>
        <div class="col-md-4" v-if="showAddClock">
          <base-button size="lg" simple block type="warning" v-on:click="addClockForm = true">add clocks</base-button>
        </div>
        <div class="col-md-4">
          <transition v-if="dataShown" name="view" appear enter-active-class="animated fadeIn delay" leave-active-class="animated fadeOut">
            <base-button class="clock-button" size="lg" simple block type="success" @click="updateData">Save settings</base-button>
          </transition>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
    import axios from "axios";
    import {setCookie, url} from "@/plugins/axios";
    import AddClockPanel from "@/pages/Clocks/AddClockPanel";
    import Modal from "@/components/Modal";
    import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";

    export default {
      props: ['employees', 'projects', 'types', 'dataShown', 'showAddClock'],
      name: "full-filter",
      components: {AddClockPanel, Modal},
      data(){
        return {
          filter: {
            employee_id:0,
            project_id:0,
            type_id:0,
            is_delete:-1,
            is_confirm:-1,
          },
          radioValue1: 'False',
          radioValue2: 'empty',
          dates: {date:null, time:{start: null, end: null},},
          addClockForm: false
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        addClock(){
          this.addClockForm = false;
          if (!this.filter.employee_id) {
            return this.notifyVue('warning', 'Please, choose employee in selector');
          }
          if (this.dates.time.start === '24:00'){
            this.dates.time.start = '00:00:01';
          }
          if (this.dates.time.end === '24:00'){
            this.dates.time.end = '23:59:59';
          }
          this.dates.time.start = this.dates.date + ' ' + this.dates.time.start;
          this.dates.time.end = this.dates.date   + ' ' + this.dates.time.end;
          let link = url + 'add-clock/' + this.filter.employee_id + '/';
          const data = { data: {"time_start":this.dates.time.start, "time_end":this.dates.time.end} };
          if (this.filter.project_id) {
            link += this.filter.project_id + '/';
            data.projectId = this.filter.project_id;
          }
          axios
            .post(link, data,
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.notifyVue('success', 'Clock was added');
                this.dates.time.start = "07:00 am";
                this.dates.time.end   = "05:00 pm";
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger', response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        timeToAmPm(time){
          let timeValue = 0;
          if (time !== null){
            time = time.split(':');
            if (time.length === 3){
              let hours = Number(time[0]);
              let minutes = Number(time[1]);
              let seconds = Number(time[2]);

              if (hours > 0 && hours <= 12) {
                timeValue = hours;
              } else if (hours > 12) {
                timeValue = hours - 12;
              } else if (hours === 0) {
                timeValue = 12;
              }
              timeValue = (timeValue < 10) ? "0" + timeValue: timeValue;
              timeValue += (minutes < 10) ? ":0" + minutes : ":" + minutes;  // get minutes
              //timeValue += (seconds < 10) ? ":0" + seconds : ":" + seconds;  // get seconds
              timeValue += (hours >= 12) ? " p.m." : " a.m.";  // get AM/PM
            }
          }
          else{timeValue = "not finished"}
          return timeValue;
        },
        getData(){
          this.filter.is_delete = this.radioValue1;
          this.filter.is_confirm = this.radioValue2;
          this.$emit('get-data', this.filter);
        },
        updateData(){
          this.$emit('update-data');
        }
      },
      mounted() {
        let date = new Date();
        this.dates.date = (date.getMonth()+1) + '/' + (date.getDate()) + '/' + date.getFullYear();
        this.dates.time.start = "07:00 am";
        this.dates.time.end   = "05:00 pm";
      }
    }
</script>

<style scoped>
  .delay{
    animation-delay: 1.0s;
  }
</style>
